module.exports = __webpack_public_path__ + "media/assets/images/number-plate-black-0c4046fbefc6c2fad8063748cc291a21.png";